<script>
  import http from '@/service/http'
  import { mapState } from 'vuex'
  import clone from 'lodash/clone'
  import truncate from 'lodash/truncate'
  import { ListSelect } from 'vue-search-select'

  export default {
    name: 'Form',
    components: {
      ListSelect
    },
    data () {
      return {
        servicos: [],
        revisao: {
          id: '',
          tipo: '',
          itens: []
        },
        item: {
          inspecao: '',
          criterio: '',
          ocorrencia: '',
          ordem: null,
          servico_id: '',
          servico: {}
        }
      }
    },
    mounted () {
      this.fecth()
    },
    watch: {
      '$route' () {
        if (this.$route.params.id != null) {
          this.fecth()
        }
      },
      hasAll () {
        if (this.hasAll) {
          this.all = true
        } else {
          this.all = false
        }
      }
    },
    methods: {
      validate: function () {
        this.$validator.validateAll().then(success => {
          if (!success) {
            return false
          } else {
            this.submit()
          }
        })
      },
      async submit () {
        const verb = this.isNew ? 'post' : 'put'
        const url = this.isNew ? '/revisao-tipos' : `/revisao-tipos/${this.revisao.id}`
        const {data} = await http[verb](url, this.revisao)
        if (data != null) {
          this.$emit('update-revisao-tipos-list', {revisao: data.revisao})
          this.$router.push({name: 'revisao-tipos.index'})
        }
      },
      async fecth () {
        this.clear()
        const {id} = this.$route.params
        if (id !== undefined) {
          const {data} = await http.get(`/revisao-tipos/${id}/edit`)
          this.revisao = data.revisao
          this.servicos = data.servicos
        } else {
          const {data} = await http.get(`/revisao-tipos/create`)
          this.servicos = data.servicos
        }
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      clear () {
        this.revisao = {
          id: '',
          tipo: '',
          itens: []
        }
      },
      validateItem: function () {
        this.$validator.validateAll('form-item').then((result) => {
          if (result) {
            this.revisao.itens.push(clone(this.item))
            this.$nextTick(() => {
              for (let key in this.item) {
                if (this.item.hasOwnProperty(key)) {
                  this.item[key] = ''
                }
              }
              this.$validator.pause()
              this.$nextTick(() => {
                this.$validator.reset()
                this.$validator.errors.clear()
                this.$validator.resume()
                window.Materialize.updateTextFields()
              })
            })
            this.item = {
              inspecao: '',
              ordem: null,
              servico_id: '',
              servico: {}
            }
          }
        })
      },
      destroyItem (index) {
        this.$swal({
          title: 'Atenção',
          text: `excluir um Item é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          if (!this.revisao.itens[index].id) {
            this.revisao.itens.splice(index, 1)
            window.Materialize.toast('Item excluído!', 4000)
          } else {
            http.delete(`/revisao-itens/${this.revisao.itens[index].id}`)
              .then(response => response.data)
              .then(data => {
                window.Materialize.toast('Item excluído!', 4000)
                this.revisao.itens.splice(index, 1)
              })
          }
        })
      },
      truncate: function (string = '') {
        return truncate(string)
      },
      onSelectServico (servico) {
        if (servico) {
          this.item.servico_id = servico.id
          this.item.servico = servico
        }
      }
    },
    computed: {
      ...mapState(['loading']),
      isNew () {
        return this.revisao.id === ''
      },
      api_url () {
        return process.env.UPLOADS_URL
      }
    }
  }
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div>

            <div class="row">
              <div class="input-field col s12">
                <input name="tipo" id="tipo" type="text" v-validate
                       data-vv-rules="required" :class="{invalid: errors.has('tipo')}"
                       v-model="revisao.tipo"/>
                <label for="tipo">*Tipo</label>
                <small class="red-text">{{ errors.first('tipo') }}</small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col s12">
              <table class="responsive-table bordered highlight">
              <tr>
                <th>Inspeção</th>
                <th>Critério</th>
                <th>Ocorrência</th>
                <th>Ordem</th>
                <th>Serviço</th>
                <th></th>
              </tr>
              <tr v-for="(item, index) in revisao.itens" v-if="revisao.itens.length > 0">
                <td>{{ item.inspecao}}</td>
                <td>{{ truncate(item.criterio) }}</td>
                <td>{{ truncate(item.ocorrencia) }}</td>
                <td>{{ item.ordem}}</td>
                <td>{{ item.servico ? item.servico.servico : '-' }}</td>
                <td>
                  <i class="material-icons pointer red-text" @click.prevent="destroyItem(index)">delete_forever</i>
                </td>
              </tr>
              <tr v-if="revisao.itens.length === 0">
                <td colspan="6" class="center-align">Nenhum item cadastrado!</td>
              </tr>
            </table>
            </div>
          </div>

          <div class="row">

            <div class="input-field col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

    <form class="col s12 m10 offset-m1" data-vv-scope="form-item">
      <div class="row">
        <div class="col s12 m10 input-field">
          <input name="inspecao" id="inspecao" type="text" v-model="item.inspecao" v-validate data-vv-rules="required"
                 :class="{invalid: errors.has('form-item.inspecao')}"/>
          <label for="inspecao">*Inspeção</label>
          <small v-show="errors.has('form-item.inspecao')" class="red-text">{{ errors.first('form-item.inspecao') }}
          </small>
        </div>
        <div class="col s12 m2 input-field">
          <input name="ordem" id="ordem" type="number" min="1" v-model="item.ordem" v-validate data-vv-rules="required"
                 :class="{invalid: errors.has('form-item.ordem')}"/>
          <label for="ordem">*Ordem</label>
          <small v-show="errors.has('form-item.ordem')" class="red-text">{{ errors.first('form-item.ordem') }}</small>
        </div>
        <div class="col s12 input-field">
          <textarea name="criterio" id="criterio" v-model="item.criterio" v-validate data-vv-rules="required"
                    class="materialize-textarea" :class="{invalid: errors.has('form-item.criterio')}"></textarea>
          <label for="criterio">*Critério</label>
          <small v-show="errors.has('form-item.criterio')" class="red-text">{{ errors.first('form-item.criterio') }}
          </small>
        </div>
        <div class="col s12 input-field">
          <textarea name="ocorrencia" id="ocorrencia" v-model="item.ocorrencia" v-validate data-vv-rules="required"
                    class="materialize-textarea" :class="{invalid: errors.has('form-item.ocorrencia')}"></textarea>
          <label for="ocorrencia">*Ocorrência</label>
          <small v-show="errors.has('form-item.ocorrencia')" class="red-text">{{ errors.first('form-item.ocorrencia')
            }}
          </small>
        </div>
      </div>
      <div class="row">
        <div class="col s12 input-field">
          <input name="servico" id="servico" type="text" v-model="item.servico.servico" placeholder="Serviço" disabled />
<!--          <label for="servico">Serviço</label>-->
        </div>
      </div>
      <div class="row">
        <div class="col s12">
          <list-select :list="servicos"
                       option-value="id"
                       option-text="servico"
                       :selected-item="item"
                       placeholder="Adicionar Serviço"
                       @select="onSelectServico">
          </list-select>
        </div>
      </div>
      <div class="row">

        <div class="input-field col s12">
          <button class="waves-effect blue waves-light btn" :disabled="loading" @click.prevent="validateItem">Adicionar</button>
          <small>*Para persistir o item adicionado é necessario salvar</small>
        </div>

      </div>
    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/os/revisao-tipo/form.vue